<template>
    <form
        v-if="editData"
        onSubmit="return false;"
        v-on:keydown="$emit('onKeydown', $event)"
        :class="{ 'sticky-actions': stickyActions && !iniDisabled }"
    >
        <div class="section blank m0 form">
            <div class="overlay" v-if="isLoading">
                <loader :text="loadingLabel ? loadingLabel : $t('saving')" />
            </div>
            <hasError :v="v" :e="errorLogInfo" v-if="!hideMessages" />

            <!-- changed notification-->
            <article v-if="!hideChanges && isChanged && !iniDisabled" class="notification is-warning">
                <span>The data has been changed, please refresh.</span>
            </article>

            <!-- the form by slot-->
            <slot></slot>

            <!-- actions-->
            <div class="action-wrapper">
                <div class="action v-center mt15-xs" v-if="!iniDisabled && !hideActions">
                    <button class="button is-success" @click.prevent="$emit('onSave')">
                        {{ btnLabel ? btnLabel : $t('save') }}
                    </button>
                    <a
                        v-if="!hideCancel && !isLoading"
                        href="javascript:void(0);"
                        class="button is-cancel"
                        @click.prevent="(payload) => $emit('onCancel', payload)"
                    >
                        {{ cancelLabel ? cancelLabel : $t('cancel') }}
                    </a>
                    <div class="ml-auto" v-if="!!this.$slots.actionRight">
                        <slot name="actionRight"></slot>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
const hasError = () => import('./../public/HasError.vue');

export default {
    name: 'aForm',
    components: {
        hasError,
    },
    props: [
        'v', //for capturing the form validation
        'iniData', //for setting the initial data
        'editData', //for capturing the changes

        'hideCancel', // for hiding the cancel button
        'hideMessages', // for hiding the error messages
        'hideActions', // for hiding the actions
        'hideChanges', //for hiding the changes notifciation
        'iniDisabled', //setting the form disabled
        'eventHandlerName', //for emitting events on the global bus
        'btnLabel', //Label of the save-button
        'cancelLabel', //Label of the cancel-button
        'loadingLabel', //Label of the loading message
        'isChanged', //when the store data is changed
        'errorLog', // for displaying details of the error
        'isError', // for displaying details of the error
        'stickyActions',
    ],
    data() {
        return {
            isDifferent: false,
            isLoading: false,
            showErrorDetails: false,
        };
    },
    computed: {
        hasError() {
            return (this.v && this.v.$error) || this.isError;
        },
        errorLogInfo() {
            if (this.errorLog) {
                return JSON.parse(JSON.stringify(this.errorLog));
            }
            return '';
        },
    },
    watch: {
        editData: {
            handler: function (newValue, oldValue) {
                //do not emit when transited from template to realdata.
                if (!this.isLoading) {
                    //compare the values
                    this.isDifferent = !(JSON.stringify(newValue) === JSON.stringify(this.iniData));
                    this.$emit('input', newValue);
                    //console.log("newValue", JSON.stringify(newValue));
                    //console.log("iniData", JSON.stringify(this.iniData));
                }
            },
            deep: true,
        },
    },
    created: function () {
        if (this.eventHandlerName) {
            document.addEventListener(`${this.eventHandlerName}.isLoading`, this.onLoading);
            document.addEventListener(`${this.eventHandlerName}.isSuccess`, this.onSuccess);
            document.addEventListener(`${this.eventHandlerName}.isError`, this.onError);
            if (this.$eventHub) {
                this.$eventHub.$on(this.eventHandlerName + '.isLoading', this.onLoading);
                this.$eventHub.$on(this.eventHandlerName + '.isSuccess', this.onSuccess);
                this.$eventHub.$on(this.eventHandlerName + '.isError', this.onError);
            }
        }
    },
    beforeDestroy() {
        if (this.eventHandlerName) {
            document.removeEventListener(`${this.eventHandlerName}.isLoading`, this.onLoading);
            document.removeEventListener(`${this.eventHandlerName}.isSuccess`, this.onSuccess);
            document.removeEventListener(`${this.eventHandlerName}.isError`, this.onError);
            if (this.$eventHub) {
                this.$eventHub.$off(this.eventHandlerName + '.isLoading', this.onLoading);
                this.$eventHub.$off(this.eventHandlerName + '.isSuccess', this.onSuccess);
                this.$eventHub.$off(this.eventHandlerName + '.isError', this.onError);
            }
        }
    },
    methods: {
        onSuccess: function () {
            //this.isError = false;
            this.isLoading = false;
        },
        onError: function () {
            //this.isError = true;
            this.isLoading = false;
        },
        onLoading: function () {
            this.isLoading = true;
        },
    },
    i18n: {
        messages: {
            en: {
                saving: 'Saving...',
                save: 'Save',
                cancel: 'Cancel',
            },
            fr: {
                saving: 'Sauvegarder...',
                save: 'Sauvegarder',
                cancel: 'Annuler',
            },
            nl: {
                saving: 'Opslaan...',
                save: 'Opslaan',
                cancel: 'Annuleren',
            },
        },
    },
};
</script>

<style lang="scss">
html body {
    .section:not(.blank):not(.transparent) {
        form.sticky-actions .action {
            background-color: #fff;
        }
    }

    form.sticky-actions > .section.form {
        position: relative;
        padding-top: 75px;
        .action {
            position: fixed;
            width: 100%;
            background-color: var(--detailmenu-bg);
            padding: 5px 0;
            margin: 0;
        }
        .action-wrapper {
            margin: 0;
            position: absolute;
            top: 0;
            left: 0;
        }
    }
}
</style>
